import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig, getIsCrane, getMsTenantFromUrl } from "./authConfig";
import AuthWrapper from "./auth/AuthWrapper";
import { AppContextProvider } from "./store";
import ErrorPage from "./pages/MissingTenantPage/ErrorPage";
import { applyThemeColorsFromUrl } from "./utils/colors";
import { CircleSpinner } from "./components/CircleSpinner";
import { getTranslation } from "./translations";
import ConfirmationModal from "./components/ConfirmationModal";
const isResetRequested = window.location.search === "?reset=true";
const openBaseUrl = () => window.location.assign(window.location.pathname);
const resetAndOpenBaseUrl = () => {
    localStorage.clear();
    sessionStorage.clear();
    openBaseUrl();
};
// Get tenant early, before component renders
const isCraneGlobal = getIsCrane();
const tenantGlobal = getMsTenantFromUrl();
const tenantToUse = isCraneGlobal ? "common" : tenantGlobal;
// Create MSAL instance outside component to ensure stability
const msalInstance = tenantToUse
    ? new PublicClientApplication(msalConfig(tenantToUse))
    : null;
const removeStateFromUrl = () => {
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.has("state")) {
        currentUrl.searchParams.delete("state");
        window.history.replaceState(null, "", currentUrl);
    }
};
const App = () => {
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        applyThemeColorsFromUrl();
        // Request persistent storage to prevent browser from clearing data
        if (navigator.storage && navigator.storage.persist) {
            navigator.storage.persist().then((granted) => {
                if (granted) {
                    console.log("Persistent storage granted");
                }
            });
        }
    }, []);
    useEffect(() => {
        const initializeMsal = async () => {
            if (!msalInstance) {
                removeStateFromUrl();
                return;
            }
            await msalInstance.initialize();
            // Handle redirect promise to complete any pending login
            await msalInstance.handleRedirectPromise();
            removeStateFromUrl();
            // Set active account if available
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
                msalInstance.setActiveAccount(accounts[0]);
            }
            // Listen for login events to set active account
            msalInstance.addEventCallback((event) => {
                if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                    msalInstance.setActiveAccount(event.payload);
                }
            });
            setIsInitialized(true);
        };
        initializeMsal();
    }, []);
    if (isResetRequested) {
        const labels = getTranslation();
        return (_jsx(ConfirmationModal, { title: labels.resetApp, message: labels.resetAppQuestion, onConfirm: resetAndOpenBaseUrl, onCancel: openBaseUrl }));
    }
    if (!isCraneGlobal && !tenantGlobal) {
        const labels = getTranslation();
        return (_jsx(ErrorPage, { title: labels.missingTenant, message: _jsxs(_Fragment, { children: [labels.missingTenantMessage, _jsx("br", {}), _jsx("code", { className: "bg-gray-200 p-2 inline-block mt-2 rounded text-sm", children: `${window.location.origin}/?tenant=<your-ms-tenant-id>` })] }) }));
    }
    if (!isInitialized || !msalInstance) {
        return (_jsx("div", { className: "flex items-center justify-center h-screen", children: _jsx(CircleSpinner, {}) }));
    }
    return (_jsx(MsalProvider, { instance: msalInstance, children: _jsx(AppContextProvider, { children: _jsx(AuthWrapper, {}) }) }));
};
export default App;
